module.exports = {"230109001":"三电街道","230109002":"太阳岛街道","230109003":"松浦街道","230109004":"万宝街道","230109005":"松北街道","230109006":"松安街道","230109007":"松祥街道","230109008":"船口街道","230109101":"对青山镇","230109102":"乐业镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230109.json
// module id = 676
// module chunks = 0